import Swiper from "swiper"
import { Navigation } from "swiper/modules"

const swiper = new Swiper(".swiper", {
  modules: [Navigation],
  loop: true,
  autoHeight: true,
  spaceBetween: 8,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
})
